import React from 'react'

import LabeledInput from '../../components/forms/LabeledInput'
import {reduxForm} from 'redux-form'

import {validatePhoneForm as validate} from '../../util/validate'

function PhoneForm(props) {

    return (

        <form className="clientdata-step__phone-input">
            <LabeledInput fieldId="note" label="" isOptional={true} placeholder="Hinweise, Wunschzeit mitteilen"/>
        </form>

    )
}

PhoneForm.propTypes = {};


export default reduxForm({form: 'phoneVerification', destroyOnUnmount: false, validate})(PhoneForm)// eslint-disable-line


/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/PhoneForm.js
 **/